var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"highlighted-box"},[_c('div',{staticClass:"box-content"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value)+"%")]),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])])])}
var staticRenderFns = []

export { render, staticRenderFns }